import { render } from "./VideoBackground.vue?vue&type=template&id=70c4f2ee"
import script from "./VideoBackground.vue?vue&type=script&lang=js"
export * from "./VideoBackground.vue?vue&type=script&lang=js"

import "./VideoBackground.vue?vue&type=style&index=0&id=70c4f2ee&lang=css"

import exportComponent from "C:\\dev\\pwillys-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__